import { useQuery } from '@tanstack/react-query';
import { listAssigneesApi, EffectiveAssigneesResponse } from '@/lib/api';

export function useListAssignees(listId: string | null | undefined, search?: string) {
  return useQuery({
    queryKey: ['listAssignees', listId, search],
    queryFn: async (): Promise<EffectiveAssigneesResponse> => {
      if (!listId) {
        return { users: [], teams: [] };
      }
      const response = await listAssigneesApi.getAssignees(listId, search);
      return response.data;
    },
    enabled: !!listId,
    staleTime: 1000 * 30, // 30 seconds
  });
}

export function useEffectiveMembers(listId: string | null | undefined) {
  return useQuery({
    queryKey: ['effectiveMembers', listId],
    queryFn: async () => {
      if (!listId) {
        return { directMembers: [], inheritedMembers: [], teams: [] };
      }
      const response = await listAssigneesApi.getEffectiveMembers(listId);
      return response.data;
    },
    enabled: !!listId,
    staleTime: 1000 * 30, // 30 seconds
  });
}
